/* Sticky mobile CTA.

   Visible only while neither the hero actions nor the form is on screen, so it
   never duplicates a button the visitor can already see and never covers the
   form it points at.

   IntersectionObserver rather than a scroll handler: a scroll handler does a
   layout read on every event, this does none. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-aw-sticky]');
  if (!bar || !('IntersectionObserver' in window)) return;

  var targets = [
    document.querySelector('.chero__actions'),
    document.querySelector('#aanvraag')
  ].filter(function (el) { return el !== null; });

  if (!targets.length) return;

  var visible = 0;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        if (!e.target.dataset.awSeen) { e.target.dataset.awSeen = '1'; visible++; }
      } else if (e.target.dataset.awSeen) {
        delete e.target.dataset.awSeen; visible--;
      }
    });
    bar.hidden = visible > 0;
  });

  targets.forEach(function (t) { io.observe(t); });
})();
